<template>
  <div class="modify-calculation-container">

    <div class="additional-info-container">
      <img :src="infoLogo" alt="Info" height="24px" />
      <div>
        Fedezd fel, hogyan alakulnának a K&H bankköltségeid eltérő tranzakciós szokásokkal – és találd meg a legjobb
        megoldást számodra!
      </div>
    </div>
    <div v-for="section in schema" :key="section.key" class="calculation-type-container">
      <div class="form-container">
        <p class="form-header">
          {{ section.title }}
        </p>

        <div v-for="row in section.rows" :key="row.key" class="form-row">
          <label class="form-label">{{ row.label }}</label>
          <div class="input-container">
            <vpd-calculation-input v-model.number="form[section.key][row.key].count" type="number" placeholder="db"
              :isSmall="true" />
            <vpd-calculation-input :value="formatAmount(form[section.key][row.key].amount)"
              @input="onAmountInput($event, section.key, row.key)" type="text" placeholder="összesen Ft"
              :isSmall="true" />
          </div>
        </div>
      </div>
    </div>

    <div class="buttons-container">
      <div class="cancel-button" @click="$emit('close-modal')">
        mégsem
      </div>
      <div class="base-button" @click="resetCalculation()">
        visszaállítom
      </div>
      <div class="recalculate-button" @click="startCalculation()">
        újrakalkulálom
      </div>
    </div>
  </div>
</template>

<script>
import "./_vpd-modify-calculation.scss";
import vpdCalculationInput from "../vpd-calculation-input/vpd-calculation-input.vue";
import infoLogo from "@/assets/info-circle.svg";

const modifyCalculationSchema = [
  {
    key: "electronicTransfer",
    title: "utalás - elektronikusan",
    rows: [
      { key: "occasional", label: "eseti" },
      { key: "regular", label: "rendszeres" },
      { key: "groupDirectDebit", label: "csoportos beszedés" },
    ],
  },
  {
    key: "paperTransfer",
    title: "utalás - papír alapon (saját fiókban)",
    rows: [
      { key: "occasional", label: "eseti" },
      { key: "regular", label: "rendszeres" },
      { key: "directDebit", label: "beszedés" },
    ],
  },
  {
    key: "telebankTransfer",
    title: "utalás - telebankban",
    rows: [
      { key: "occasional", label: "eseti" },
      { key: "regular", label: "rendszeres" },
      { key: "directDebit", label: "beszedés" },
    ],
  },
  {
    key: "cashWithdrawal",
    title: "készpénzfelvétel",
    rows: [
      { key: "ownAtm", label: "saját ATM-ből" },
      { key: "otherAtm", label: "idegen ATM-ből" },
      { key: "ownBranch", label: "saját fiókban" },
    ],
  },
];

export default {
  name: "vpd-modify-calculation",
  components: {
    vpdCalculationInput
  },
  props: {
    config: {
      type: Object,
      required: false,
    },
    initialForm: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      infoLogo,
      value: null,
      schema: modifyCalculationSchema,
      form: JSON.parse(JSON.stringify(this.initialForm)),
    }
  },
  methods: {
    startCalculation() {
      this.$emit("startCalculation", this.form, this.type);
    },
    resetCalculation() {
      window.location.href = "https://kh.portal.bankszamlakivonat.hu/accounts";
    },
    formatAmount(value) {
      if (value == null || value === "") return "";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },

    onAmountInput(val, sectionKey, rowKey) {
      const raw = String(val).replace(/\s+/g, "");
      const num = Number(raw);

      this.form[sectionKey][rowKey].amount = isNaN(num) ? 0 : num;
    }
  }
};
</script>
